<template>
    <section>
        <div class="container container--fluid">
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="text-h5">
                        درخواست تسویه حساب دوره ای
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-card class="mb-2">
                <v-row no-gutters>
                    <v-col
                            cols="6"
                            sm="6"
                    >
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title class="text-h5">
                                    {{resellers[settlementRequest.reseller_id] ? resellers[settlementRequest.reseller_id].name : 'ناشناخته'}}
                                </v-list-item-title>
                                <v-list-item-subtitle>درخواست شده در {{ getJalaliDate(settlementRequest.created_at * 1000) }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-card-text>
                            <p>                               درخواست تسویه از : {{ getJalaliDate(settlementRequest.from_date * 1000) }}</p>
                            <p>درخواست تسویه تا : {{ getJalaliDate(settlementRequest.to_date * 1000) }}</p>
                            <hr>
                            <h4 v-if="resellers[settlementRequest.reseller_id]">واریز مبلغ به شماره شبا {{resellers[settlementRequest.reseller_id].iban_number}} به نام {{resellers[settlementRequest.reseller_id].iban_full_name}}</h4>
                        </v-card-text>
                    </v-col>
                    <v-col
                            cols="6"
                            sm="6"

                    >
                        <v-simple-table dense>
                            <tbody>
                                <tr>
                                    <th>
                                        کل
                                    </th>
                                    <td class="text-left">
                                        {{$t('display_price', { price : $n( totalAmount)})}}
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        جریمه
                                    </th>
                                    <td class="text-left">
                                        {{$t('display_price', { price : $n( settlementRequest.settlement_fee)})}}
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        پرداختی
                                    </th>
                                    <td class="text-left">
                                        {{$t('display_price', { price : $n( totalPaid)})}}
                                    </td>
                                </tr>
                                <tr bgcolor="#eaeaea">
                                    <th>
                                        مانده
                                    </th>
                                    <td class="text-left">
                                        {{$t('display_price', { price : $n( balance )})}}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-card-actions class="mt-2">
                    <v-spacer></v-spacer>
                    <router-link
                        :to="{ name: 'Commissions', query: { filters: [{ column_name : 'created_at', value: [settlementRequest.from_date,settlementRequest.to_date], operand: 'Between' },{ column_name : 'reseller_id', value: settlementRequest.reseller_id, operand: 'IsEqualTo' }], orders: [{column_name : 'id', value : 'desc'}] } }"
                        class="d-block font-weight-medium no-decoration"
                    >
                      نمایش لیست کمیسیون ها
                    </router-link>

                    <v-btn
                            :disabled="balance == 0"
                            elevation="2"
                            small
                            @click="showCreateAccountingReceipt()"
                    >ثبت فیش پرداختی</v-btn>

                    <v-btn
                            :disabled="balance != 0"
                            @click="completeSettlementRequest()"
                            elevation="2"
                            small
                            color="success"
                    >اعلان تسویه</v-btn>
                </v-card-actions>
            </v-card>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="text-h5">
                        رسید های پرداختی
                    </v-list-item-title>
                    <v-list-item-subtitle>رسیدهای پرداختی ما به همکار تجاری</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-card class="mb-2">
                <v-simple-table dense :loading="true">
                    <thead>
                    <tr bgcolor="#eaeaea">
                        <th>
                            تاریخ پرداخت
                        </th>
                        <th>
                            مبلغ پرداختی
                        </th>
                        <th>
                            سند فیش پرداختی
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(accountingReceipt,index) in accountingReceipts" :key="index">
                        <td>
                            {{ getJalaliDate(accountingReceipt.paid_at * 1000) }}
                            <v-chip
                                    v-if="accountingReceipt.deleted_at"
                                    color="error"
                                    x-small
                            >
                                حذف شده در :
                                {{ getJalaliDate(accountingReceipt.deleted_at * 1000) }}
                            </v-chip>
                        </td>
                        <td>
                            {{$t('display_price', { price : $n( accountingReceipt.amount)})}}
                        </td>
                        <td>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small :loading="downloadFileLoading.indexOf(accountingReceipt.id) > -1" @click="downloadFile(accountingReceipt)" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-cloud-download-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{$t('download_fax_file')}}</span>
                            </v-tooltip>

                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small :disabled="accountingReceipt.deleted_at" :loading="deletingIds.indexOf(accountingReceipt.id) > -1" @click="deleteAccountingReceipt(accountingReceipt)" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{$t('delete')}}</span>
                            </v-tooltip>
                        </td>
                    </tr>
                    <tr v-if="accountingReceipts.length <= 0">
                        <td colspan="3" class="text-center">هیچ رکوردی یافت نشد.</td>
                    </tr>
                    </tbody>
                </v-simple-table>
            </v-card>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="text-h5">
                        گزارش کمیسیون های
                    </v-list-item-title>
                    <v-list-item-subtitle>کمیسیون هایی زیر در این درخواست تسویه می شوند</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-card class="mb-2">
                <v-simple-table dense :loading="true">
                    <thead>
                    <tr bgcolor="#eaeaea">
                        <th>
                            نوع کمیسیون
                        </th>
                        <th>
                            درصد کمیسیون
                        </th>
                        <th>
                            کل پرداختی
                        </th>
                        <th>
                            مبلغ کمیسیون
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(report,index) in commissionOverviewReport" :key="index">
                            <td>
                                {{$t('commission_type')[report.type]}}
                            </td>
                            <td>
                                {{report.commission_rate}}
                            </td>
                            <td>
                                {{$t('display_price', { price : $n( report.total_amount * 100 / report.commission_rate )})}}
                            </td>
                            <td>
                                {{$t('display_price', { price : $n( report.total_amount)})}}
                            </td>
                        </tr>
                        <tr v-if="commissionOverviewReport.length <= 0">
                            <td colspan="3" class="text-center">هیچ رکوردی یافت نشد.</td>
                        </tr>
                    </tbody>

                </v-simple-table>
            </v-card>
        </div>
        <AccountingReceiptForm
                v-if="AccountingReceipt"
                :item="AccountingReceipt"
                @close="AccountingReceipt = null"
                @submit="syncAccountingReceipts"
        ></AccountingReceiptForm>
    </section>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    import AccountingReceiptForm from "../components/AccountingReceiptForm";
    import SettlementRequestsService from "../services/SettlementRequestsService";
    import CommissionsService from "../services/CommissionsService";
    import AccountingReceiptsService from "../services/AccountingReceiptsService";
    import RequestList from "../services/RequestList";
    import StorageService from "../services/StorageService";

    export default {
        components : {
            AccountingReceiptForm
        },
        created(){
            this.syncSettlementRequest();
            this.syncResellers();
            this.syncCommissionOverviewReport();
            this.syncAccountingReceipts();
        },
        computed : {
            ...mapState({
                resellers: state => state.resellers.resellers
            }),
            totalAmount(){
                return this.commissionOverviewReport
                    .reduce( (totalAmount, {total_amount}) => parseInt(total_amount) + totalAmount, 0);
            },
            totalPaid(){
                return this.accountingReceipts
                    .filter( (accountingReceipt) => !accountingReceipt.deleted_at)
                    .reduce( (totalAmount, {amount}) => parseInt(amount) + totalAmount, 0);
            },
            balance(){
                return this.totalAmount - this.settlementRequest.settlement_fee - this.totalPaid;
            },
        },
        data(){
            return {
                deletingIds : [],
                downloadFileLoading : [],
                settlementRequest : SettlementRequestsService.getDefault(),
                AccountingReceipt : null,
                accountingReceipts : [],
                commissionOverviewReport : [],
            }
        },
        methods : {
            ...mapActions({
                syncResellers: 'resellers/sync'
            }),
            async syncCommissionOverviewReport() {
                this.loading = true;
                try {
                    let {
                        data
                    } = await CommissionsService.getOverviewReport('yearly', {
                        settlement_request_id: {
                            column_name : 'settlement_request_id',
                            operand : 'IsEqualTo',
                            value : this.$route.params.id
                        }
                    });
                    this.commissionOverviewReport = data.value.commission_report;
                } finally {
                    this.loading = false;
                }
            },
            async syncAccountingReceipts() {
                this.loading = true;
                let requestList = new RequestList();

                requestList.addFilter('settlement_request_id','IsEqualTo', this.$route.params.id);

                try {
                    let {
                        data
                    } = await AccountingReceiptsService.list(requestList);
                    this.accountingReceipts = data.value.accounting_receipts;
                } finally {
                    this.loading = false;
                }
            },
            async syncSettlementRequest() {
                this.loading = true;
                let requestList = new RequestList();

                requestList.addFilter('id','IsEqualTo', this.$route.params.id);

                try {
                    let {
                        data
                    } = await SettlementRequestsService.list(requestList);
                    this.settlementRequest = data.value.settlement_requests.pop();
                } finally {
                    this.loading = false;
                }
            },
            async deleteAccountingReceipt(accountingReceipt) {
                if(!
                        confirm( this.$t(
                            'accountingReceiptDeleteQuestion', {
                                amount : this.$t('display_price', {
                                    price: this.$n(accountingReceipt.amount)
                                })
                            }
                        ))
                ){
                    return false;
                }
                this.deletingIds.push(accountingReceipt.id);

                try {
                    let {
                        data
                    } = await AccountingReceiptsService.delete(accountingReceipt.id);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                    this.syncAccountingReceipts();
                    this.deletingIds.splice(this.deletingIds.indexOf(accountingReceipt.id), 1);

                } finally {
                    this.loading = false;
                }
            },
            showCreateAccountingReceipt(){
                let AccountingReceipt = AccountingReceiptsService.getDefault();
                AccountingReceipt.settlement_request_id = this.$route.params.id;
                this.AccountingReceipt = AccountingReceipt;
            },
            async downloadFile(accountingReceipt){
                this.downloadFileLoading.push(accountingReceipt.id);

                let request = new RequestList();
                request.addFilter('id','IsEqualTo', accountingReceipt.file_id);

                let {data} = await StorageService.list(request);

                this.downloadFileLoading.splice(this.downloadFileLoading.indexOf(accountingReceipt.id), 1);

                let link = document.createElement("a");
                // If you don't know the name or want to use
                // the webserver default set name = ''
                link.href = data.value.files.pop().url;
                link.target = '_blank';
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                link.remove();

            },
            async completeSettlementRequest(){
                if(!
                        confirm("آیا مطمئن به اعلان تسویه می باشید؟")
                ){
                    return false;
                }

                try {
                    let {
                        data
                    } = await SettlementRequestsService.complete(this.settlementRequest.id);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                    this.syncSettlementRequest();
                } finally {
                    this.loading = false;
                }
            }

        }
    }
</script>